"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function AmazonrdsGreenMultitoneFilled(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__amazonrds-green-multitone-filled__clip0_13467_100)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF730E",
    d: "M8.984 5.182V2.217c0-.218-.038-.406-.113-.565a.816.816 0 00-.345-.368 1.186 1.186 0 00-.588-.131c-.21 0-.394.036-.553.107a.815.815 0 00-.356.303.783.783 0 00-.125.44H5.329c0-.266.063-.517.19-.755.127-.242.307-.456.541-.642.238-.19.521-.339.85-.446A3.64 3.64 0 018.027 0c.487 0 .921.083 1.301.25.385.162.686.408.904.736.222.33.333.743.333 1.243v2.804c0 .321.02.597.059.826.043.226.107.422.19.589v.1H9.216a2.37 2.37 0 01-.173-.617 4.846 4.846 0 01-.06-.749zm.22-2.55l.012.934h-.993a2.44 2.44 0 00-.648.077 1.197 1.197 0 00-.457.214.867.867 0 00-.268.333 1.01 1.01 0 00-.089.433c0 .159.036.302.107.428a.817.817 0 00.321.303c.143.072.31.107.5.107.277 0 .518-.055.724-.166.206-.115.367-.254.482-.416a.898.898 0 00.184-.464l.451.678a2.657 2.657 0 01-.25.517 2.33 2.33 0 01-.427.511c-.174.158-.384.29-.63.392a2.2 2.2 0 01-.856.155 2.44 2.44 0 01-1.117-.25 1.98 1.98 0 01-.778-.683 1.755 1.755 0 01-.286-.987c0-.34.064-.642.19-.903.127-.262.316-.481.565-.66.25-.182.559-.319.927-.41a5.184 5.184 0 011.278-.142h1.058z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9549",
    d: "M6.053 8.072H9.946V16H6.053z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF730E",
    d: "M10.551 8.025l2.787-1.357v7.641l-2.787 1.56V8.024zM5.449 8.025L2.662 6.668v7.641l2.787 1.56V8.024zM13.943 6.378l1.605-1.803v7.798l-1.605 1.696V6.38zM2.057 6.378L.452 4.575v7.798l1.605 1.696V6.38z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__amazonrds-green-multitone-filled__clip0_13467_100"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H16V16H0z"
  }))));
}

AmazonrdsGreenMultitoneFilled.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
AmazonrdsGreenMultitoneFilled.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = AmazonrdsGreenMultitoneFilled;
exports["default"] = _default;